"use client";
import { useIsMobile } from "@/hooks/useIsMobile";
import { PropsWithChildren } from "react";
import EmptyProductsFilter from "./EmptyProductsFilter";
import SortDropdown, {
  SortTypes,
} from "@/app/components/lib/sort-dropdown/SortDropdown";
import { Col, Row } from "@/utils/bootstrap";
import PCSort_Filter from "./PCSort_Filter";
import GeneralApiLoader from "@/app/components/lib/loaders/GeneralApiLoader";
import { useAtom } from "jotai";
import { isEmptyFilterAtom } from "@/hooks/useCurrentFilters";
import EmptyCategory from "../../category-page/EmptyCategory";
import { serverLoadingAtom } from "@/hooks/headerHooks";

interface Props {
  productsLenght: number;
  loading: boolean;
  isCategoryPage: boolean;
  isInfiniteScrollLoading?: boolean;
}
const ProductContainer: React.FC<PropsWithChildren & Props> = ({
  children,
  productsLenght,
  loading: loadingProducts,
  isCategoryPage,
  isInfiniteScrollLoading,
}) => {
  const mobile = useIsMobile();
  const [isEmptyFilter] = useAtom(isEmptyFilterAtom);
  const [serverLoading] = useAtom(serverLoadingAtom);
  const loading = serverLoading || loadingProducts;
  return (
    <>
      {mobile ? (
        <>
          {productsLenght === 0 && !loading && !isInfiniteScrollLoading ? (
            <EmptyProductsFilter />
          ) : (
            <>
              <SortDropdown type={SortTypes.products} backdrop />
              {/* <div style={{ marginTop: 16 }} /> */}
              {loading ? <GeneralApiLoader /> : children}
            </>
          )}
        </>
      ) : (
        <Row className="m-0" style={{ gap: 32 }}>
          <Col className="p-0 col-auto" style={{ width: 306 }}>
            <PCSort_Filter />
          </Col>
          <Col className="p-0">
            {loading || (productsLenght === 0 && isInfiniteScrollLoading) ? (
              <GeneralApiLoader />
            ) : productsLenght === 0 && !isInfiniteScrollLoading ? (
              <>
                {isEmptyFilter && isCategoryPage ? (
                  <EmptyCategory />
                ) : (
                  <EmptyProductsFilter />
                )}
              </>
            ) : (
              <>{children}</>
            )}
          </Col>
        </Row>
      )}
    </>
  );
};

export default ProductContainer;
